import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { makeServer } from "./server";
import {BrowserRouter as Router} from "react-router-dom";
import { AuthContextProvider } from './contexts/AuthContext';
import { UserContext, UserContextProvider } from './contexts/UserContext';
import { FollowingContext, FollowingContextProvider } from './contexts/FollowingContext';
import { PostContextProvider, PostsContext } from './contexts/PostsContext';

makeServer();

export {UserContext};
export {FollowingContext};
export {PostsContext};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
    <AuthContextProvider>
    <UserContextProvider>
    <FollowingContextProvider>
    <PostContextProvider>
      <App />
    </PostContextProvider> 
    </FollowingContextProvider>
    </UserContextProvider>  
    </AuthContextProvider>  
    </Router>  
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
